var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.328,
    height: 17,
    viewBox: "0 0 14.328 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "share_icon",
    "data-name": "share icon",
    d: "M1219.864,672.213s-4.75-10.926,6.175-13.3v-3.7l7.125,6.074-7.125,6.65v-3.8S1220.814,664.137,1219.864,672.213Z",
    transform: "translate(-1218.837 -655.213)",
    fill: "#e3e3e3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/share_icon.a6a0b1ecf21ac3fdf91dbd8375169c48.svg";
export { ForwardRef as ReactComponent };